
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    lng: 'es', // por defecto o podés detectar de URL
    fallbackLng: 'es',
    interpolation: { escapeValue: false }
  });

/**
 * Carga traducciones personalizadas desde el backend y las mergea con las locales
 * @param {Object} customTranslations - Objeto con traducciones por idioma { es: {...}, en: {...} }
 */
export const loadCustomTranslations = (customTranslations) => {
  if (!customTranslations || typeof customTranslations !== 'object') {
    console.warn('⚠️ No se recibieron traducciones personalizadas válidas');
    return;
  }

  console.log('🔍 Traducciones recibidas:', customTranslations);

  Object.keys(customTranslations).forEach(lang => {
    if (customTranslations[lang] && typeof customTranslations[lang] === 'object') {
      // Mergear traducciones: las del backend sobreescriben las locales
      const currentTranslations = i18n.getResourceBundle(lang, 'translation') || {};
      const mergedTranslations = { ...currentTranslations, ...customTranslations[lang] };

      i18n.addResourceBundle(lang, 'translation', mergedTranslations, true, true);
      console.log(`✅ Traducciones personalizadas cargadas para idioma: ${lang}`, customTranslations[lang]);

      // Verificar que se cargó correctamente
      console.log(`🔍 Verificando "Filter by type" en ${lang}:`, i18n.t('Filter by type', { lng: lang }));
    }
  });
};

export default i18n;
